import apiWrapper from 'common/api/api-wrapper';
import { IAPIErrorContent } from 'common/api/type-def';

import { IAddUserErrorResponse } from 'features/Settings/UserManagement/api/type-def';

import {
	IRolesApiResponse,
	IGroupsApiResponse,
	IModulePermissionResponseList,
	IDataAcessModuleResponse,
	IRoleActionResponse,
	IPermissionRole,
	ICreateGroupRequestPayload,
	IPermissionGroup,
} from './type-def';

const { REACT_APP_USER_MANAGEMENT_SERVICE_URL } = process.env;

export const getRolesTableData = async (params: any) => {
	const sortKey = params?.sortKey ? params?.sortKey : 'roleName';
	const sortDirection = params?.sortDirection ? params?.sortDirection : 'asc';
	const resp = await apiWrapper.get<IRolesApiResponse, IAPIErrorContent>(
		`${REACT_APP_USER_MANAGEMENT_SERVICE_URL}/roles?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize}&sortBy=${sortKey}&sortOrderBy=${sortDirection}`,
	);
	return resp;
};

export const getGroupsTableData = async (params: any) => {
	const sortKey = params?.sortKey ? params?.sortKey : 'groupName';
	const sortDirection = params?.sortDirection ? params?.sortDirection : 'asc';
	const resp = await apiWrapper.get<IGroupsApiResponse, IAPIErrorContent>(
		`${REACT_APP_USER_MANAGEMENT_SERVICE_URL}/groups?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize}&sortBy=${sortKey}&sortOrderBy=${sortDirection}`,
	);

	return resp;
};

export const getModulePermissions = async () => {
	const resp = await apiWrapper.get<
		IModulePermissionResponseList[],
		IAPIErrorContent
	>(`${REACT_APP_USER_MANAGEMENT_SERVICE_URL}/modules`);
	return resp;
};

export const getDataPermissions = async () => {
	const resp = await apiWrapper.get<
		IDataAcessModuleResponse[],
		IAPIErrorContent
	>(`${REACT_APP_USER_MANAGEMENT_SERVICE_URL}/data-permission`);
	return resp;
};

export const createRoleData = async (data: any) => {
	const resp = await apiWrapper.post<
		IRoleActionResponse | IAddUserErrorResponse
	>(`${REACT_APP_USER_MANAGEMENT_SERVICE_URL}/role`, data);
	return resp;
};
export const createGroupData = async (data: any) => {
	const resp = await apiWrapper.post<
		ICreateGroupRequestPayload | IAddUserErrorResponse
	>(`${REACT_APP_USER_MANAGEMENT_SERVICE_URL}/group`, data);
	return resp;
};

export const getGroupById = async (id: string) => {
	const resp = await apiWrapper.get<IPermissionGroup, IAPIErrorContent>(
		`${REACT_APP_USER_MANAGEMENT_SERVICE_URL}/groups/${id}`,
	);
	return resp;
};

export const updateGroupData = async (data: any, id: string) => {
	const resp = await apiWrapper.put<
		ICreateGroupRequestPayload,
		IAPIErrorContent
	>(`${REACT_APP_USER_MANAGEMENT_SERVICE_URL}/groups/${id}`, data);
	return resp;
};

export const getRoleById = async (id: string) => {
	const resp = await apiWrapper.get<IPermissionRole, IAPIErrorContent>(
		`${REACT_APP_USER_MANAGEMENT_SERVICE_URL}/roles/${id}`,
	);
	return resp;
};

export const updateRoleData = async (data: any, id: string) => {
	const resp = await apiWrapper.put<IRoleActionResponse, IAPIErrorContent>(
		`${REACT_APP_USER_MANAGEMENT_SERVICE_URL}/roles/${id}`,
		data,
	);
	return resp;
};

export const deleteRoleById = async (data: any, id: string) => {
	const resp = await apiWrapper.delete<IRoleActionResponse, IAPIErrorContent>(
		`${REACT_APP_USER_MANAGEMENT_SERVICE_URL}/roles/${id}`,
		data,
	);
	return resp;
};

export const deleteGroupById = async (data: any, id: string) => {
	const resp = await apiWrapper.delete<IRoleActionResponse, IAPIErrorContent>(
		`${REACT_APP_USER_MANAGEMENT_SERVICE_URL}/groups/${id}`,
		data,
	);
	return resp;
};
